import _toConsumableArray from "/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/toConsumableArray";
import _Set from "/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/core-js/set";

export var state = function state() {
  return {

    // === pending approve registration ====
    userPendingRegList: [],
    // === pending approve registration ====

    // === pending Approval List ====
    userCollection: {},
    moduleSessionCollection: {}
    // === pending Approval List ====
  };
};

export var mutations = {
  setUserPendingRegList: function setUserPendingRegList(state, userPendingRegList) {
    state.userPendingRegList = userPendingRegList;
  },
  updatePendingRegUser: function updatePendingRegUser(state, user) {
    var tempUser = new _Set(state.userPendingRegList);
    tempUser.delete(user);
    state.userPendingRegList = [].concat(_toConsumableArray(tempUser));
  },
  setPendingCollection: function setPendingCollection(state, _ref) {
    var pAppCollection = _ref.pAppCollection,
        msCollection = _ref.msCollection;

    state.userCollection = pAppCollection;
    state.moduleSessionCollection = msCollection;
  },
  onStatusUpdate: function onStatusUpdate(state, _ref2) {
    var rowItem = _ref2.rowItem,
        moduleSessionActorId = _ref2.moduleSessionActorId;

    var tempList = new _Set(state.userCollection[moduleSessionActorId]);
    tempList.delete(rowItem);
    state.userCollection[moduleSessionActorId] = [].concat(_toConsumableArray(tempList));
  }
};


//////////////////
// WEBPACK FOOTER
// ./store/pendingAction.js
// module id = ./store/pendingAction.js
// module chunks = 20